import { useSetRecoilState } from 'recoil';
import { useQuery } from '@apollo/client';
import { useConditionalEffect, usePrevious } from 'react-delta';

import { PREFERENCES_QUERY } from 'common/queries/apolloQueries';
import { preferencesState } from 'components/common/Managers/PreferencesManager.state';

function PreferencesManager() {
  const { data } = useQuery(PREFERENCES_QUERY);
  const setPreferences = useSetRecoilState(preferencesState);
  const prevPreferencesData = usePrevious(data);

  useConditionalEffect(() => {
    const { __typename, ...preferences } = data.preferences;
    setPreferences(preferences);
  }, !prevPreferencesData && !!data);

  return <></>;
}

export default PreferencesManager;
